import { render } from "lit-html";
import { travelData, onChangeGuests } from "../../state/travelData";

export class GuestSelectorView extends HTMLElement {
	constructor() {
		super();
		onChangeGuests(this.update.bind(this));
	}

	connectedCallback() {
		this.update();
	}

	render() {
		return travelData.numAllGuests;
	}

	update() {
		render(this.render(), this, { host: this });
	}
}

customElements.define("esc-guest-selector-view", GuestSelectorView);
